









import {
  Component,
  Vue,
  Config,
  TModelBase,
  Model,
  Watch,
  Prop,
} from "@/common";
import AMapLoader from "@amap/amap-jsapi-loader";

@Component({})
export default class ShowMap extends TModelBase {
  switchShowTModel(val) {
    if (this.propkey !== "" && val === true) {
      AMapLoader.load({
        //首次调用 load
        key: "10fb7fec97640aeef42f9ba3b5b39b13", //首次load key为必填
        version: "2.0",
        plugins: ["AMap.Scale", "AMap.ToolBar"],
      })
        .then((AMap) => {
          this.$http
            .get("Biz/Track/GetLngLat", { params: { Y_NO: this.propkey } })
            .then((res) => {
              if (res.data.data.length > 0) {
                var map = new AMap.Map("container", {
                  zoom: 15,
                  center: [res.data.data[0].LONG, res.data.data[0].LAT],
                });
                map.addControl(new AMap.Scale());
                map.addControl(
                  new AMap.ToolBar({
                    position: {
                      top: "60px",
                      right: "40px",
                    },
                  })
                );

                var path = [];

                res.data.data.forEach((item) => {
                  path.push([item.LONG, item.LAT]);
                  var marker = new AMap.Marker({
                    position: new AMap.LngLat(item.LONG, item.LAT), // 经纬度对象，如 new AMap.LngLat(116.39, 39.9); 也可以是经纬度构成的一维数组[116.39, 39.9]
                  });

                  marker.on("click", function () {
                    infoWindow(
                      item.ADDRESS,
                      "登记时间: " + item.TIMES.replace("T", " ").substr(0, 19)
                    ).open(map, marker.getPosition());
                  });

                  map.add(marker);
                });

                var polyline = new AMap.Polyline({
                  map: map,
                  path: path,
                  showDir: true,
                  strokeColor: "#28F", //线颜色
                  // strokeOpacity: 1,     //线透明度
                  strokeWeight: 6, //线宽
                  // strokeStyle: "solid"  //线样式
                });
                map.add(polyline);

                function infoWindow(title, info) {
                  var content = [];
                  content.push(info);
                  return new AMap.InfoWindow({
                    isCustom: true, //使用自定义窗体
                    content: createInfoWindow(title, content.join("<br/>")),
                    offset: new AMap.Pixel(16, -45),
                  });
                }

                //构建自定义信息窗体
                function createInfoWindow(title, content) {
                  var info = document.createElement("div");
                  info.className = "custom-info input-card content-window-card";

                  // 定义顶部标题
                  var top = document.createElement("div");
                  var titleD = document.createElement("div");
                  var closeX = document.createElement("img");
                  top.className = "info-top";
                  titleD.innerHTML = title;
                  closeX.src = "https://webapi.amap.com/images/close2.gif";
                  closeX.onclick = closeInfoWindow;

                  top.appendChild(titleD);
                  top.appendChild(closeX);
                  info.appendChild(top);

                  // 定义中部内容
                  var middle = document.createElement("div");
                  middle.className = "info-middle";
                  middle.style.backgroundColor = "white";
                  middle.innerHTML = content;
                  info.appendChild(middle);

                  // 定义底部内容
                  var bottom = document.createElement("div");
                  bottom.className = "info-bottom";
                  bottom.style.position = "relative";
                  bottom.style.top = "0px";
                  bottom.style.margin = "0 auto";
                  var sharp = document.createElement("img");
                  sharp.src = "https://webapi.amap.com/images/sharp.png";
                  bottom.appendChild(sharp);
                  info.appendChild(bottom);
                  return info;
                }

                //关闭信息窗体
                function closeInfoWindow() {
                  map.clearInfoWindow();
                }
              }
            })
            .catch((res) => {
              new AMap.Map("container", { center: [116.39, 39.9] });
            });
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  @Prop({})
  private propkey!: String;
}
